exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pager{margin-top:15px;margin-bottom:15px}.pager,.pager button{display:flex;justify-content:center}.pager button{padding:10px;background:#e4e4e3;border:1px solid #c9c7c4;border-right:none;align-items:center;font-size:14px;outline:none}.pager button:hover{background:#eeeeec}.pager button:focus{background:#d7d7d6}.pager button:first-child{border-radius:5px 0 0 5px}.pager button:last-child{border-radius:0 5px 5px 0;border-right:1px solid #c9c7c4}.pager button:only-child{border-radius:5px}.pager button.active{background:#d5d4d1}.pager button svg{width:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Pager/Pager.scss
// module id = 869
// module chunks = 0